var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppTransition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"assistant-loader"},[_c('Loader',{attrs:{"small":""}}),_vm._v(" "),_c('span',{staticClass:"assistant-loader__text"},[_vm._v("\n      "+_vm._s(_vm.$t('assistant.loadingText'))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }